import * as _ from "lodash-es";
import * as qs from "query-string";
import React, { Component } from "react";
import { Dock } from "react-dock";
import Modal from "react-modal";
import IDeleteTokenDTO from "../../../../models/DTO/IDeleteTokenDTO";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetSupplierUsersTokens from "../../../../models/DTO/IGetSupplierUsersTokens";
import IGetSupplierUserVendorsDTO from "../../../../models/DTO/IGetSupplierUserVendorsDTO";
import IGetVendorsDTO from "../../../../models/DTO/IGetVendorsDTO";
import IOnDeleteTokenDTO from "../../../../models/DTO/IOnDeleteTokenDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetSupplierUsersTokens from "../../../../models/DTO/IOnGetSupplierUsersTokens";
import IOnGetSupplierUserVendorsDTO from "../../../../models/DTO/IOnGetSupplierUserVendorsDTO";
import IOnGetVendorsDTO from "../../../../models/DTO/IOnGetVendorsDTO";
import IOnResendTokenEmailDTO from "../../../../models/DTO/IOnResendTokenEmailDTO";
import IOnUpdateSupplierUserVendorMapDTO from "../../../../models/DTO/IOnUpdateSupplierUserVendorMapDTO";
import IResendTokenEmailDTO from "../../../../models/DTO/IResendTokenEmailDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IAction from "../../../../models/IAction";
import IConnection_Token from "../../../../models/IConnection_Token";
import IConnection_TokenUI from "../../../../models/IConnection_TokenUI";
import INotification from "../../../../models/INotification";
import IOwTableCols from "../../../../models/IOwTableCols";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import SortOrderEnum from "../../../../models/SortOrderEnum";
import SocketService from "../../../../services/SocketService";
import BetaBadge from "../../../shared/BetaBadge/BetaBadge";
import FishbowlAssignUser from "../../../shared/FishbowlAssignUser/FishbowlAssignUser";
import OwActionBar from "../../../shared/OwActionBar/OwActionBar";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTable from "../../../shared/OwTable/OwTable";
import PaginationBar from "../../../shared/PaginationBar/PaginationBar";
import SupplierUserActionBtns from "./SupplierUserActionBtns/SupplierUserActionBtns";
import SupplierUserCsvModalUpload from "./SupplierUserCsvModalUpload/SupplierUserCsvModalUpload";
import SupplierUserFilter from "./SupplierUserFilter/SupplierUserFilter";
import "./SupplierUsers.scss";

import SupplierUserSidebar from "./SupplierUserSidebar/SupplierUserSidebar";
import SupplierUserVendorAccess from "./SupplierUserVendorAccess/SupplierUserVendorAccess";
import Breadcrumbs from "../../../shared/Breadcrumbs/Breadcrumbs";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IBreadcrumbs from "../../../../models/IBreadcrumbs";
import IUpdateSupplierUserVendorMapDTO from "../../../../models/DTO/IUpdateSupplierUserVendorMapDTO";

import { Socket } from "socket.io-client";
import { ConfirmDeleteOverlayFn } from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import IOnGetSupplierUsageDTO from "../../../../models/DTO/IOnGetSupplierUsageDTO";
import IGetSupplierUsageDTO from "../../../../models/DTO/IGetSupplierUsageDTO";
import UIService from "../../../../services/UIService";
import { OwDeleteEditActions } from "../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import {SearchSection} from "../../../shared/SearchSection/SearchSection";

type Props = {
    socket: Socket;
    setActivityIndicator: (activityIndicator: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    location: any;
    history: any;
};

type State = {
    supplierUserTokens: any[];
    totalSupplierUsers: number;
    limit: number;
    offset: number;
    catalogs: any[];
    priceGroups: IPrice_Group[];
    hasAvailableTokens: boolean;
    purchasedTokensCount: number;
    supplierVendorTokens: IConnection_Token[];
    dockComponent: any;
    isDockVisible: boolean;
    workingOnUser: IConnection_TokenUI | null;
    isOnline: boolean;
    sourceConfirmDeleteElem?: HTMLElement | null;
    confirmDeleteRow: string | null;
    columns: IOwTableCols[];
    isDataFetching: boolean;
    initialData: boolean;
    supplierVendorTokensComplete: any;
    checkedRows: { [key: string]: boolean };
    actionBarActions: IAction[];
    modalComponent: any;
    modalIsOpen: boolean;
    sortCol: string;
    sortOrder: SortOrderEnum;
    queryString?: string;
    isReset?: boolean;
    navItems: IBreadcrumbs[];
    supplierUsage: IOnGetSupplierUsageDTO | undefined;
};

class SupplierUsers extends Component<Props, State> {
    deleteIndex: any;
    rowToDelete: IConnection_Token | undefined;
    assignOverlayRef: any;

    constructor(props: any) {
        super(props);

        const columns: IOwTableCols[] = [
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: this.editColFn,
            },
            {
                title: "name",
                valueProp: "User",
                valueSubProp: "name",
                isSortable: true,
                sortOrderFn: () => {
                    return this.state.sortOrder;
                },
                sortFn: this.toggleSortDir,
            },
            {
                title: "email",
                valueProp: "",
                valueSubProp: "",
                renderFn: this.renderEmailFn,
                renderFnEmitsRow: true,
                isSortable: true,
                sortOrderFn: () => {
                    return this.state.sortOrder;
                },
                sortFn: this.toggleSortDir,
            },
            {
                title: "user_type",
                valueProp: "User_Type",
                valueSubProp: "name",
                translateValue: true,
            },
            {
                title: "access",
                valueProp: "Access_Type",
                valueSubProp: "name",
                translateValue: true,
            },
            {
                title: "catalog_lock",
                valueProp: "Catalog",
                valueSubProp: "name",
            },
            {
                title: "price_group_lock",
                valueProp: "Price_Group",
                valueSubProp: "value",
                renderFn: this.renderPriceGroupLock,
                renderFnEmitsRow: true,
            },
            {
                title: "",
                valueProp: "",
                isActionsCol: true,
                renderFn: this.actionBtnsFn,
            },
        ];

        if (this.props.supplierModel.has_hide_pricing) {
            const hidePricingCol: IOwTableCols = {
                title: "hide_pricing",
                valueProp: "hide_pricing",
                renderFn: this.renderHidePricingFn,
            };

            columns.splice(4, 0, hidePricingCol);
        }

        const actionBarActions: IAction[] = [];

        if (this.props.supplierModel.Supplier_Integration.has_fishbowl) {
            actionBarActions.push({
                name: "fishbowl",
                isGroup: true,
                groupActions: [
                    {
                        name: "assign_user",
                        fn: this.showAssignFishbowlUserModal,
                        disabledFn: this.hasOnlyOneChecked,
                    },
                ],
            });
        }

        this.state = {
            supplierUserTokens: [],
            supplierVendorTokens: [],
            limit: 10,
            offset: 0,
            totalSupplierUsers: 0,
            purchasedTokensCount: 0,
            catalogs: [],
            priceGroups: [],
            hasAvailableTokens: false,
            dockComponent: null,
            isDockVisible: false,
            workingOnUser: null,
            isOnline: navigator.onLine,
            columns,
            initialData: true,
            isDataFetching: false,
            supplierVendorTokensComplete: [],
            checkedRows: {},
            actionBarActions,
            modalComponent: null,
            modalIsOpen: false,
            sortCol: this.getSortCol(),
            sortOrder: this.getSortOrder(),
            navItems: [
                { title: "Dashboard", url: "/dashboard" },
                { title: "Users", url: "/users" },
            ],
            confirmDeleteRow: null,
            supplierUsage: undefined,
        };
    }

    async componentDidMount() {
        this.props.socket.on(EndpointsEnum.TokenOnGetSupplierUsage, this.onGetSupplierUsage);
        this.props.socket.on(EndpointsEnum.TokenOnGetSupplierUsersTokens, this.onGetSupplierUsersTokens);
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
        this.props.socket.on(EndpointsEnum.TokenOnResendTokenEmail, this.onResendTokenEmail);
        this.props.socket.on(EndpointsEnum.TokenOnDeleteToken, this.onDeleteToken);
        this.props.socket.on(EndpointsEnum.SupplierOnGetSupplierUserVendors, this.onGetSupplierUserVendors);
        this.props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierUserVendorMap, this.onUpdateSupplierUserVendorMap);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);

        this.getSupplierUsage();
        this.getSupplierUsers();
        this.getVendors();
        this.getCatalogs();

        document.title = "Orderwerks >> Users";
    }

    componentWillUnmount(): void {
        this.props.socket.off(EndpointsEnum.TokenOnGetSupplierUsage, this.onGetSupplierUsage);
        this.props.socket.off(EndpointsEnum.TokenOnGetSupplierUsersTokens, this.onGetSupplierUsersTokens);
        this.props.socket.off(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
        this.props.socket.off(EndpointsEnum.TokenOnResendTokenEmail, this.onResendTokenEmail);
        this.props.socket.off(EndpointsEnum.TokenOnDeleteToken, this.onDeleteToken);
        this.props.socket.off(EndpointsEnum.SupplierOnGetSupplierUserVendors, this.onGetSupplierUserVendors);
        this.props.socket.off(EndpointsEnum.SupplierOnUpdateSupplierUserVendorMap, this.onUpdateSupplierUserVendorMap);
        this.props.socket.off(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
    }

    toggleSortDir = (sortCol: string, sortOrder: SortOrderEnum, apiSortCol?: string) => {
        const queryString = this.getQueryString(apiSortCol || sortCol, sortOrder);

        this.setState({ sortOrder, sortCol, queryString }, () => {
            this.getSupplierUsers();
        });
    };

    getQueryString = (sortCol: string, sortOrder: SortOrderEnum, includeQueryString?: string): string => {
        const query: string[] = [];
        let queryString = "";

        if (!_.isNil(sortCol)) {
            query.push(`order_by=${sortCol}`);
        }

        if (!_.isNil(sortOrder)) {
            query.push(`order_dir=${sortOrder}`);
        }

        if (query.length) {
            if (includeQueryString) {
                queryString = includeQueryString + "&";
            } else {
                queryString = "?";

                // if (this.state.queryStringArr) {
                //     query = [...query, ...this.state.queryStringArr];
                // }
            }

            queryString += query.join("&");
        } else {
            if (includeQueryString) {
                return includeQueryString;
            }
        }

        return queryString;
    };

    getSortOrder = (): SortOrderEnum => {
        let order = SortOrderEnum.ASC;

        const parsedSearch = qs.parse(this.props.location.search);

        const order_dir = _.get(parsedSearch, "order_dir", undefined);

        if (order_dir === SortOrderEnum.DESC) {
            order = SortOrderEnum.DESC;
        }

        return order;
    };

    getSortCol = (): string => {
        let col = "name";

        const parsedSearch = qs.parse(this.props.location.search);

        const order_by = _.get(parsedSearch, "order_by", undefined);

        if (order_by) {
            col = order_by.toString();
        }

        return col;
    };

    hasOnlyOneChecked = (): boolean => {
        const keys = Object.keys(this.state.checkedRows);

        let hasOnlyOneChecked = true;

        let count = 0;

        for (const key of keys) {
            if (this.state.checkedRows[key]) {
                count++;
            }
        }

        if (count > 1) {
            hasOnlyOneChecked = false;
        }

        if (!count) {
            hasOnlyOneChecked = false;
        }

        return !hasOnlyOneChecked;
    };

    showAssignFishbowlUserModal = () => {
        const checkedRowGuid = this.getCheckedRowGuid();

        const supplierUserToken = this.state.supplierUserTokens.find((token: IConnection_Token) => {
            return token.guid === checkedRowGuid;
        });

        const modalComponent = (
            <FishbowlAssignUser
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                supplierUserToken={supplierUserToken}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    renderHidePricingFn = (has_hide_pricing: boolean) => {
        if (has_hide_pricing) {
            return "Y";
        } else {
            return "--";
        }
    };

    resendToken = (token: IConnection_Token) => {
        const payload: IResendTokenEmailDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            tokenGuid: token.guid,
        };

        this.props.socket.emit("resendTokenEmail", payload);
    };

    onResendTokenEmail = (data: IOnResendTokenEmailDTO) => {
        const notification: INotification = {
            message: "successfully_resent_token",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);
    };

    actionBtnsFn = (supplierUserToken: IConnection_Token, rowIndex: number) => {
        return (
            <SupplierUserActionBtns
                supplierUserToken={supplierUserToken}
                toggleDockFn={this.toggleDock}
                toggleConfirmDeleteFn={this.toggleConfirmDelete}
                resendTokenEmailFn={this.resendToken}
                rowIndex={rowIndex}
            />
        );
    };

    getCheckedRowGuid = (): string => {
        const checkedItems = Object.keys(this.state.checkedRows);

        let rowGuid = "";

        for (const checkedItem of checkedItems) {
            if (this.state.checkedRows[checkedItem]) {
                rowGuid = checkedItem;
            }
        }

        return rowGuid;
    };

    setChecked = (e: any) => {
        console.log("setChecked", e);
        const checkedGuid = e.target.name;

        const checkedRows = this.state.checkedRows;

        // only allow 1 row to be checked
        for (const key of Object.keys(checkedRows)) {
            if (checkedRows[key]) {
                checkedRows[key] = false;
            }
        }

        checkedRows[checkedGuid] = e.target.value;

        this.setState({
            checkedRows,
        });
    };

    editColFn = (row: IConnection_Token) => {
        return (
            <div className={"no-wrap d-flex align-items-center"}>
                {this.props.supplierModel.Supplier_Integration.has_fishbowl ? (
                    <OwCheckbox
                        name={row.guid}
                        truthyVal={true}
                        falsyVal={false}
                        fn={this.setChecked}
                        checked={this.state.checkedRows[row.guid]}
                    />
                ) : null}
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {}}
                    onEditClickFn={() => {
                        this.showSupplierUserSidebar(row);
                    }}
                    hideTrash={true}
                />
                {this.props.supplierModel.has_rep_groups ? (
                    <i title={"Sales Rep"} className={"ms-2 me-2 fad fa-user-tie " + (row.is_sales_rep ? "text-success" : "text-muted")} />
                ) : null}
                {row.dashboard_order_entry ? (
                    <i
                        title={"Dashboard Order Entry"}
                        className={"fad fa-chalkboard " + (row.dashboard_order_entry ? "text-success" : "text-muted")}
                    />
                ) : null}
            </div>
        );
    };

    getRegistrationUrl = (row: IConnection_Token): string => {
        const value = row.value;

        const siteUrl = SocketService.getStaticSiteUrl();

        let register = `/register?t=${value}`;

        if (siteUrl.indexOf("8080") >= 0) {
            register = `/register.html?t=${value}`;
        }

        const registrationUrl = `${siteUrl}${register}`;

        return registrationUrl;
    };

    renderPriceGroupLock = (row: IConnection_Token) => {
        if (row.Price_Group) {
            return <div>{row.Price_Group.value}</div>;
        } else {
            return null;
        }
    };

    renderEmailFn = (row: IConnection_Token) => {
        if (!row.User) {
            return (
                <div>
                    <div>
                        {row.recipient} <BetaBadge title={"pending"} />
                    </div>
                    <div className={"registration-url text-small"}>
                        <OwLabel title={"registration_url"} noBottomMargin={true} className={"me-2"} />
                        <a href={this.getRegistrationUrl(row)} target={"_blank"} rel="noreferrer">
                            {this.getRegistrationUrl(row)}
                        </a>
                    </div>
                </div>
            );
        } else {
            return <div>{row.User.email}</div>;
        }
    };

    allowCreateUsers = (allow: boolean) => {
        // This prevents an unlimited call depth issue;
        if (allow === this.state.hasAvailableTokens) {
            return;
        }

        this.setState({
            hasAvailableTokens: allow,
        });
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit("getCatalogs", payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    getVendors = () => {
        const userData: IGetVendorsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            nameGuidOnly: true,
            offset: 0,
            limit: 10,
        };

        this.props.socket.emit("getVendors", userData);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const supplierVendorTokens = data.supplierVendorTokens;

        this.setState({
            // supplierVendorTokensComplete: data.supplierVendorTokens,
            supplierVendorTokens,
        });
    };

    getSupplierUsage = () => {
        const payload: IGetSupplierUsageDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetSupplierUsage, payload);
    };

    onGetSupplierUsage = (data: IOnGetSupplierUsageDTO) => {
        let availableTokens = false;

        if (data.internalUsersCount < data.allowedInternalUsersCount) {
            availableTokens = true;
        }

        if (data.repUsersCount < data.allowedRepUsersCount) {
            availableTokens = true;
        }

        if (data.readOnlyUsersCount < data.allowedReadOnlyUsersCount) {
            availableTokens = true;
        }

        this.setState({
            hasAvailableTokens: availableTokens,
            supplierUsage: data,
        });
    };

    saveSelectedVendors = (userGuid: string, selectedVendors: any) => {
        const payload: IUpdateSupplierUserVendorMapDTO = {
            userToUpdateGuid: userGuid,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorMap: selectedVendors.map((vendor: any) => {
                return vendor.value;
            }),
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierUserVendorMap, payload);
    };

    getSupplierUserVendors = (supplierUserToken: IConnection_TokenUI) => {
        const payload: IGetSupplierUserVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            userToGetGuid: supplierUserToken.User?.guid || "",
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SupplierGetSupplierUserVendors, payload);
    };

    onGetSupplierUserVendors = (data: IOnGetSupplierUserVendorsDTO) => {
        const workingOnUser = this.state.workingOnUser;

        if (workingOnUser) {
            workingOnUser.selectedVendors = data.vendors;
            const dockComponent = this.getDockComponent(workingOnUser);

            this.setState({
                dockComponent,
                isDockVisible: !this.state.isDockVisible,
                workingOnUser,
            });
        }
    };

    getDockComponent = (supplierUserToken: IConnection_TokenUI) => {
        return (
            <SupplierUserVendorAccess
                socket={this.props.socket}
                saveSelectedVendorsFn={this.saveSelectedVendors}
                workingOnUser={supplierUserToken}
                supplierVendorTokens={this.state.supplierVendorTokensComplete}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );
    };

    toggleDockComponent = (component: any, callbackFn?: any) => {
        if (component) {
            this.setState(
                {
                    dockComponent: component,
                    isDockVisible: true,
                },
                callbackFn
            );
        } else {
            this.setState(
                {
                    dockComponent: null,
                    isDockVisible: false,
                },
                callbackFn
            );
        }
    };

    toggleDock = (supplierUserToken?: IConnection_TokenUI) => {
        // console.log("toggleDock", supplierUserToken, this.state.isDockVisible);

        if (!this.state.isDockVisible && supplierUserToken) {
            this.setState(
                {
                    workingOnUser: supplierUserToken,
                },
                () => {
                    this.getSupplierUserVendors(supplierUserToken);
                }
            );
        } else {
            // const dockComponent = this.getDockComponent();

            this.setState({
                dockComponent: null,
                isDockVisible: !this.state.isDockVisible,
                workingOnUser: supplierUserToken || null,
            });
        }
    };

    toggleConfirmDelete = (data: IConnection_Token, rowIndex: number, rowElem: HTMLElement | null) => {
        this.deleteIndex = rowIndex;

        this.rowToDelete = data;

        this.setState({
            confirmDeleteRow: `row-${rowIndex}`,
            sourceConfirmDeleteElem: rowElem,
        });
    };

    commitDelete = () => {
        // console.log("TODO Commit Delete: " + this.deleteIndex);

        const row = this.rowToDelete;

        if (row) {
            const data: IDeleteTokenDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                tokenGuid: row.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenDeleteToken, data);

            this.rowToDelete = undefined;
        }

        this.setState({
            sourceConfirmDeleteElem: null,
            confirmDeleteRow: null,
        });
    };

    onDeleteToken = (data: IOnDeleteTokenDTO) => {
        this.getSupplierUsers();
    };

    cancelDelete = () => {
        // @ts-expect-error

        this.deleteIndex = undefined;

        this.setState({
            sourceConfirmDeleteElem: null,
            confirmDeleteRow: null,
        });
    };

    cancelSidebar = () => {
        this.props.toggleSidebar(false);
        this.getSupplierUsers();
        this.getSupplierUsage();
    };

    getSupplierUserSidebarComponent = (supplierUser: any) => {
        // console.log("props.catalogs", this.state.catalogs);

        return (
            <SupplierUserSidebar
                cancel={this.cancelSidebar}
                // priceGroups={this.props.priceGroups}
                catalogs={this.state.catalogs}
                supplierUser={supplierUser}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );
    };

    showSupplierUserSidebar = (supplierUser?: IConnection_TokenUI) => {
        const sidebarComp = this.getSupplierUserSidebarComponent(supplierUser);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar(true);
    };

    getSupplierUsers = () => {
        if (!this.props.userModel || !this.props.supplierModel) {
            return null;
        }

        const payload: IGetSupplierUsersTokens = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            offset: this.state.offset,
            limit: this.state.limit,
            queryString: this.state.queryString,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetSupplierUsersTokens, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetSupplierUsersTokens = (data: IOnGetSupplierUsersTokens) => {
        this.setState({
            supplierUserTokens: data.tokens.supplierUserTokens,
            totalSupplierUsers: data.tokens.totalSupplierUsers,
            isDataFetching: false,
            initialData: false,
        });
    };

    onUpdateSupplierUserVendorMap = (data: IOnUpdateSupplierUserVendorMapDTO) => {
        const notification: INotification = {
            message: "updated_supplier_user_vendor_map",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.tc,
        };

        this.props.notifyFn(null, notification);
    };

    onPaginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getSupplierUsers();
            }
        );
    };

    closeModal = () => {
        this.setState({
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    showUploadModal = () => {
        const modalComponent = (
            <SupplierUserCsvModalUpload
                closeModalFn={this.closeModal}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            modalIsOpen: true,
            modalComponent,
        });
    };

    searchFn = (queryString: string, searchResults: any, reset: boolean) => {
        const state: any = {
            queryString,
            searchResults,
            offset: 0,
            isReset: true,
        };

        if (reset) {
            state.sortCol = "name";
            state.sortOrder = SortOrderEnum.ASC;
        }

        this.setState(state, () => {
            this.getSupplierUsers();
        });
    };

    getUsage = () => {
        if (!this.state.totalSupplierUsers) {
            return null;
        }

        let hasDiffUserTypes = false;

        if (this.state.supplierUsage?.allowedRepUsersCount || this.state.supplierUsage?.allowedReadOnlyUsersCount) {
            hasDiffUserTypes = true;
        }

        return (
            <div>
                <div className={"d-flex"}>
                    <div className={"card " + (UIService.isMainViewLight() ? "" : "text-white bg-dark")}>
                        <div className="card-header">
                            <OwLabel title={"usage"} isBold={true} />
                        </div>
                        <div className="card-body">
                            <div className={"d-flex flex-column"}>
                                <div className={"d-flex"}>
                                    <div className={"w-3r text-end"}>
                                        {this.state.supplierUsage?.internalUsersCount}/{this.state.supplierUsage?.allowedInternalUsersCount}
                                    </div>
                                    <OwLabel className={"ms-1"} title={hasDiffUserTypes ? "internal_users" : "users"} />
                                </div>
                                {this.state.supplierUsage?.allowedRepUsersCount ? (
                                    <div className={"d-flex"}>
                                        <div className={"w-3r text-end"}>
                                            {this.state.supplierUsage?.repUsersCount}/{this.state.supplierUsage?.allowedRepUsersCount}
                                        </div>
                                        <OwLabel className={"ms-1"} title={"rep_users"} />
                                    </div>
                                ) : null}
                                {this.state.supplierUsage?.allowedReadOnlyUsersCount ? (
                                    <div className={"d-flex"}>
                                        <div className={"w-3r text-end"}>
                                            {this.state.supplierUsage?.readOnlyUsersCount}/
                                            {this.state.supplierUsage?.allowedReadOnlyUsersCount}
                                        </div>
                                        <OwLabel className={"ms-1"} title={"read_only_users"} />
                                    </div>
                                ) : null}
                            </div>
                            <div>
                                <OwLabel
                                    leftIconClass={"fas fa-question-circle"}
                                    className={"font-small text-muted"}
                                    title={"contact_support_more_users"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        if (!this.props.supplierModel) {
            return null;
        }

        return (
            <div className="SupplierUsers pb-2 w-100 position-relative">
                {/*<Breadcrumbs navItems={this.state.navItems} />*/}

                <div className={"row"}>
                    <div className={"col-12 col-sm-6"}>
                        <div className={"d-flex align-items-end"}>
                            <OwTitle title={"users"} leftIconName={"fad fa-users"} className={"mt-3"} />
                            <div className={"ms-3"}>
                                <OwButton
                                    id={"create"}
                                    title={"create"}
                                    className={"btn-warning mb-2"}
                                    disabled={!this.state.hasAvailableTokens}
                                    fn={() => {
                                        this.showSupplierUserSidebar();
                                    }}
                                    leftIconClass={"fas fa-plus"}
                                />
                            </div>
                        </div>

                        <div className={"mt-3"}>{this.getUsage()}</div>
                    </div>
                </div>

                <div className={"d-flex"}>
                    <div className={"ms-auto"}>
                        <OwButton
                            title={"upload_csv"}
                            className={"btn-danger mb-2"}
                            disabled={!this.state.hasAvailableTokens}
                            fn={() => {
                                this.showUploadModal();
                            }}
                            leftIconClass={"fas fa-upload"}
                        />
                    </div>
                </div>

                <div className={"mb-2"}>
                    <SearchSection>
                        <SupplierUserFilter
                            searchActive={this.state.isDataFetching}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            socket={this.props.socket}
                            notifyFn={this.props.notifyFn}
                            sortCol={this.state.sortCol}
                            sortDir={this.state.sortOrder}
                            searchFn={this.searchFn}
                            location={this.props.location}
                            history={this.props.history}
                        />
                    </SearchSection>

                </div>

                <div>
                    <OwActionBar
                        toggleSmallTable={() => {}}
                        colToggledFn={() => {}}
                        columns={{}}
                        hideColumnToggle={true}
                        actions={this.state.actionBarActions}
                    />
                </div>

                <div className="row">
                    <div className="col-12 table-responsive position-relative">
                        <ConfirmDeleteOverlayFn
                            targetElem={this.state.confirmDeleteRow}
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            message={"connections.are_sure_revoke_token"}
                            leftAdjustment={-12}
                            nestedParentElem={"users-table"}
                            skipMainView={true}
                        />

                        <OwTable
                            id={"users-table"}
                            columns={this.state.columns}
                            dataSet={this.state.supplierUserTokens}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={this.state.isDataFetching}
                            initialData={this.state.initialData}
                            tableConfig={{ tableHover: true, alignHeadersMiddle: true }}
                            currentSortCol={this.state.sortCol}
                        />
                    </div>

                    <div className={"col-12"}>
                        <PaginationBar
                            limit={this.state.limit}
                            offset={this.state.offset}
                            totalRecords={this.state.totalSupplierUsers}
                            onPaginationChanged={this.onPaginationChanged}
                        />
                    </div>
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}
                        style={{}}>
                        {this.state.modalComponent}
                    </Modal>
                </div>

                <Dock
                    size={0.45}
                    dockStyle={{
                        backgroundColor: "var(--main-bg-color)",
                        color: "var(--main-text-color)",
                    }}
                    position="bottom"
                    isVisible={this.state.isDockVisible}>
                    {" "}
                    <div className={"SupplierUsersDockWrapper"}>
                        <div className="text-end">
                            <span
                                className="pointer"
                                onClick={() => {
                                    this.toggleDock();
                                }}>
                                X
                            </span>
                        </div>

                        <div className="">{this.state.dockComponent}</div>
                    </div>
                </Dock>
            </div>
        );
    }
}

export default SupplierUsers;
